import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { GET_SELLER_STORE } from "../../api/seller-store";
import ExpandToggleButton from "../../pre-order/components/expand-toggle-button";
import { useReserveException } from "../../pre-order/context/reserve-exception-provider";
import { HiChevronRight } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { getExposeType, type ExposeType } from "../../../../utils/store-expose";

const HeaderPreorderSales = ({
  toggleDisplay,
  isExpanded,
}: {
  toggleDisplay: () => void;
  isExpanded: boolean;
}) => {
  const { preOrderSchedules, dateStatuses } = useReserveException();
  const { data: storeData, refetch } = useQuery(GET_SELLER_STORE, {
    fetchPolicy: "cache-and-network",
  });
  const [isVisible, setIsVisible] = useState<ExposeType>("X");
  const navigate = useNavigate();

  useEffect(() => {
    if (storeData) {
      setIsVisible(getExposeType(storeData?.getSellerStore?.pack));
    }
  }, [storeData]);

  // ---------------- 타 컴포넌트의 상태 업데이트 대비 ----------------
  useEffect(() => {
    refetch(); // refetch 함으로 노출 상태 싱크를 맞춰 줌.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preOrderSchedules, dateStatuses]); // 각각 [일정 요약 상태, 캘린더 일정 상태]
  // ---------------- 타 컴포넌트의 상태 업데이트 대비 ----------------
  return (
    <div className="fixed top-0 left-0 right-0 z-50 max-w-[742px] mx-auto flex items-center justify-between px-4 w-full bg-white border-b border-gray-200 h-[60px]">
      <div className="flex flex-col">
        <div className="flex items-center gap-2">
          <div
            className={clsx(
              "w-4 h-4 rounded-full transition-colors duration-300 shadow-sm",
              isVisible === "오늘" || isVisible === "내일"
                ? "bg-green-500 ring-2 ring-green-200"
                : "bg-gray-500 ring-2 ring-gray-200"
            )}
          ></div>
          <div className="font-semibold text-md">
            {isVisible === "오늘"
              ? "예약 판매 노출중 (오늘)"
              : isVisible === "내일"
              ? "예약 판매 노출중 (내일)"
              : "예약 판매 미노출"}
          </div>
        </div>
        <div
          onClick={() => {
            navigate(
              `/boss/store-preview/card/${storeData?.getSellerStore?.id}`
            );
          }}
          className="ml-6 font-semibold underline underline-offset-2 text-gray-500 text-sm flex items-center"
        >
          내 매장 노출 보기 <HiChevronRight className="w-3.5 h-3.5" />
        </div>
      </div>
      <ExpandToggleButton
        toggleDisplay={toggleDisplay}
        isExpanded={isExpanded}
      />
    </div>
  );
};

export default HeaderPreorderSales;
